import { DamageType } from './damage-types';

export enum ChassisDamageLocation {
  AIR_SYSTEM = 'AIR SYSTEM',
  BRAKES = 'BRAKES',
  ELECTRICAL = 'ELECTRICAL',
  FRAME = 'FRAME',
  LANDING_GEAR = 'LANDING GEAR',
  LIGHTS = 'LIGHTS',
  LOCKS = 'LOCKS',
  MARKINGS = 'MARKINGS',
  MISC = 'MISC',
  SLIDER = 'SLIDER',
  SUSPENSION = 'SUSPENSION',
  WHEELS = 'WHEELS'
}

const enum ChassisDamagePart {
  AIR_LINE = 'AIR LINE',
  AIR_TANK = 'AIR TANK',
  GLADHAND = 'GLADHAND',
  GLADHAND_SEAL = 'GLADHAND SEAL',
  HOSE_SEPARATORS = 'HOSE SEPARATORS',
  VALVE = 'VALVE',
  BRAKE_SHOES = 'BRAKE SHOES',
  S_CAM_BUSHING = 'S CAM BUSHING',
  BRAKE_DRUM = 'BRAKE DRUM',
  MAXI_CHAMBER = 'MAXI CHAMBER',
  S_CAM = 'S CAM',
  SLACK_ADJUSTER = 'SLACK ADJUSTER',
  SEVEN_WAY_CABLE = 'SEVEN WAY CABLE',
  SEVEN_WAY_PLUG = 'SEVEN WAY PLUG',
  SHORT = 'SHORT',
  WIRING = 'WIRING',
  BOLSTER = 'BOLSTER',
  BOLSTER_GUSSET = 'BOLSTER GUSSET',
  CROSSMEMBER = 'CROSSMEMBER',
  FILLER_PLATE = 'FILLER PLATE',
  ICC_BUMPER = 'ICC BUMPER',
  ICC_UPRIGHTS = 'ICC UPRIGHTS',
  KING_PIN = 'KING PIN',
  KING_PIN_PLATE = 'KING PIN PLATE',
  LIGHT_HOUSING = 'LIGHT HOUSING',
  MAIN_RAIL = 'MAIN RAIL',
  MUD_FLAP = 'MUD FLAP',
  MUD_FLAP_BRACKET = 'MUD FLAP BRACKET',
  CRANK_HANDLE = 'CRANK HANDLE',
  CRANK_HANDLE_RETAINER = 'CRANK HANDLE RETAINER',
  CRANK_SHAFT = 'CRANK SHAFT',
  DUST_COVER = 'DUST COVER',
  DIAGONAL_BRACE = 'DIAGONAL BRACE',
  EAR_BRACKET = 'EAR BRACKET',
  GEAR_BOX = 'GEAR BOX',
  GEAR_LEG = 'GEAR LEG',
  MOUNTING_BOX = 'MOUNTING BOX',
  MOUNTING_BOX_GUSSET = 'MOUNTING BOX GUSSET',
  NON_GEAR_LEG = 'NON GEAR LEG',
  SAND_SHOE = 'SAND SHOE',
  SAND_SHOE_AXLE = 'SAND SHOE AXLE',
  SAND_SHOE_AXLE_HOUSING = 'SAND SHOE AXLE HOUSING',
  TIMING_BAR = 'TIMING BAR',
  CROSS_BRACE = 'CROSS BRACE',
  ABS_LIGHT = 'ABS LIGHT',
  LICENSE_PLATE_LIGHT = 'LICENSE PLATE LIGHT',
  MARKER_LIGHT = 'MARKER LIGHT',
  TAIL_LIGHT = 'TAIL LIGHT',
  ICC_MARKER_LIGHT = 'ICC MARKER LIGHT',
  SAFETY_BRACKET = 'SAFETY BRACKET',
  LOCK_GUIDE = 'LOCK GUIDE',
  LOCK_HANDLE = 'LOCK HANDLE',
  SAFETY_LATCH = 'SAFETY LATCH',
  PIN_LOCK = 'PIN LOCK',
  RISER_BLOCK = 'RISER BLOCK',
  TWIST_LOCK = 'TWIST LOCK',
  REFLECTOR = 'REFLECTOR',
  CONSPICUITY_TAPE = 'CONSPICUITY TAPE',
  UNIT_PREFIX_NUMBER = 'UNIT PREFIX NUMBER',
  DOCUMENT_HOLDER = 'DOCUMENT HOLDER',
  LICENSE_PLATE = 'LICENSE PLATE',
  REGISTRATION = 'REGISTRATION',
  SLIDER_ASSEBLY = 'SLIDER ASSEBLY',
  INDEX_HOLE = 'INDEX HOLE',
  INDEX_PIN = 'INDEX PIN',
  SLIDER_HANDLE = 'SLIDER HANDLE',
  SLIDER_GUIDE = 'SLIDER GUIDE',
  SLIDER_STOP = 'SLIDER STOP',
  SUB_FRAME = 'SUB FRAME',
  AXLE = 'AXLE',
  EQUALIZER = 'EQUALIZER',
  HANGER = 'HANGER',
  REBOUND_BOLT = 'REBOUND BOLT',
  RADIUS_ROD = 'RADIUS ROD',
  SPRING = 'SPRING',
  STABALIZER_BAR = 'STABALIZER BAR',
  U_BOLTS = 'U BOLTS',
  OIL_HUB_CAP = 'OIL HUB CAP',
  HUB_CAP_GASKET = 'HUB CAP GASKET',
  WHEEL_STUD_NUT = 'WHEEL STUD NUT',
  GREASE_HUB_CAP = 'GREASE HUB CAP',
  CLEAT = 'CLEAT'
}

type T_ChassisLocationPart = { [P in ChassisDamageLocation]: keyof ChassisDamageTypes[P] };

/* prettier-ignore */
export interface ChassisLocationPart extends T_ChassisLocationPart {
  [ChassisDamageLocation.AIR_SYSTEM]: Extract<
    ChassisDamagePart,
    | ChassisDamagePart.AIR_LINE
    | ChassisDamagePart.AIR_TANK
    | ChassisDamagePart.GLADHAND
    | ChassisDamagePart.GLADHAND_SEAL
    | ChassisDamagePart.HOSE_SEPARATORS
    | ChassisDamagePart.VALVE
  >;
  [ChassisDamageLocation.BRAKES]: Extract<
    ChassisDamagePart,
    | ChassisDamagePart.BRAKE_SHOES
    | ChassisDamagePart.S_CAM_BUSHING
    | ChassisDamagePart.BRAKE_DRUM
    | ChassisDamagePart.MAXI_CHAMBER
    | ChassisDamagePart.S_CAM
    | ChassisDamagePart.SLACK_ADJUSTER
  >;
  [ChassisDamageLocation.ELECTRICAL]: Extract<
    ChassisDamagePart,
    | ChassisDamagePart.SEVEN_WAY_CABLE
    | ChassisDamagePart.SEVEN_WAY_PLUG
    | ChassisDamagePart.SHORT
    | ChassisDamagePart.WIRING
  >;
  [ChassisDamageLocation.FRAME]: Extract<
    ChassisDamagePart,
    | ChassisDamagePart.BOLSTER
    | ChassisDamagePart.BOLSTER_GUSSET
    | ChassisDamagePart.CROSSMEMBER
    | ChassisDamagePart.FILLER_PLATE
    | ChassisDamagePart.ICC_BUMPER
    | ChassisDamagePart.ICC_UPRIGHTS
    | ChassisDamagePart.KING_PIN
    | ChassisDamagePart.KING_PIN_PLATE
    | ChassisDamagePart.LIGHT_HOUSING
    | ChassisDamagePart.MAIN_RAIL
    | ChassisDamagePart.MUD_FLAP
    | ChassisDamagePart.MUD_FLAP_BRACKET
  >;
  [ChassisDamageLocation.LANDING_GEAR]: Extract<
    ChassisDamagePart,
    | ChassisDamagePart.CRANK_HANDLE
    | ChassisDamagePart.CRANK_HANDLE_RETAINER
    | ChassisDamagePart.CRANK_SHAFT
    | ChassisDamagePart.DUST_COVER
    | ChassisDamagePart.DIAGONAL_BRACE
    | ChassisDamagePart.EAR_BRACKET
    | ChassisDamagePart.GEAR_BOX
    | ChassisDamagePart.GEAR_LEG
    | ChassisDamagePart.MOUNTING_BOX
    | ChassisDamagePart.MOUNTING_BOX_GUSSET
    | ChassisDamagePart.NON_GEAR_LEG
    | ChassisDamagePart.SAND_SHOE
    | ChassisDamagePart.SAND_SHOE_AXLE
    | ChassisDamagePart.SAND_SHOE_AXLE_HOUSING
    | ChassisDamagePart.TIMING_BAR
    | ChassisDamagePart.CROSS_BRACE
  >;
  [ChassisDamageLocation.LIGHTS]: Extract<
    ChassisDamagePart,
    | ChassisDamagePart.ABS_LIGHT
    | ChassisDamagePart.LICENSE_PLATE_LIGHT
    | ChassisDamagePart.MARKER_LIGHT
    | ChassisDamagePart.TAIL_LIGHT
    | ChassisDamagePart.ICC_MARKER_LIGHT
  >;
  [ChassisDamageLocation.LOCKS]: Extract<
    ChassisDamagePart,
    | ChassisDamagePart.SAFETY_BRACKET
    | ChassisDamagePart.LOCK_GUIDE
    | ChassisDamagePart.LOCK_HANDLE
    | ChassisDamagePart.SAFETY_LATCH
    | ChassisDamagePart.PIN_LOCK
    | ChassisDamagePart.RISER_BLOCK
    | ChassisDamagePart.TWIST_LOCK
  >;
  [ChassisDamageLocation.MARKINGS]: Extract<
    ChassisDamagePart,
    | ChassisDamagePart.REFLECTOR
    | ChassisDamagePart.CONSPICUITY_TAPE
    | ChassisDamagePart.UNIT_PREFIX_NUMBER
  >;
  [ChassisDamageLocation.MISC]: Extract<
    ChassisDamagePart,
    | ChassisDamagePart.DOCUMENT_HOLDER
    | ChassisDamagePart.LICENSE_PLATE
    | ChassisDamagePart.REGISTRATION
  >;
  [ChassisDamageLocation.SLIDER]: Extract<
    ChassisDamagePart,
    | ChassisDamagePart.SLIDER_ASSEBLY
    | ChassisDamagePart.INDEX_HOLE
    | ChassisDamagePart.INDEX_PIN
    | ChassisDamagePart.SLIDER_HANDLE
    | ChassisDamagePart.SLIDER_GUIDE
    | ChassisDamagePart.SLIDER_STOP
    | ChassisDamagePart.SUB_FRAME
  >;
  [ChassisDamageLocation.SUSPENSION]: Extract<
    ChassisDamagePart,
    | ChassisDamagePart.AXLE
    | ChassisDamagePart.EQUALIZER
    | ChassisDamagePart.HANGER
    | ChassisDamagePart.REBOUND_BOLT
    | ChassisDamagePart.RADIUS_ROD
    | ChassisDamagePart.SPRING
    | ChassisDamagePart.STABALIZER_BAR
    | ChassisDamagePart.U_BOLTS
  >;
  [ChassisDamageLocation.WHEELS]: Extract<
    ChassisDamagePart,
    | ChassisDamagePart.OIL_HUB_CAP
    | ChassisDamagePart.HUB_CAP_GASKET
    | ChassisDamagePart.WHEEL_STUD_NUT
    | ChassisDamagePart.GREASE_HUB_CAP
    | ChassisDamagePart.CLEAT
  >;
}

export const chassisLocationPartMap: { [P in keyof ChassisLocationPart]: ChassisDamagePart[] } = {
  [ChassisDamageLocation.AIR_SYSTEM]: [
    ChassisDamagePart.AIR_LINE,
    ChassisDamagePart.AIR_TANK,
    ChassisDamagePart.GLADHAND,
    ChassisDamagePart.GLADHAND_SEAL,
    ChassisDamagePart.HOSE_SEPARATORS,
    ChassisDamagePart.VALVE
  ],
  [ChassisDamageLocation.BRAKES]: [
    ChassisDamagePart.BRAKE_SHOES,
    ChassisDamagePart.S_CAM_BUSHING,
    ChassisDamagePart.BRAKE_DRUM,
    ChassisDamagePart.MAXI_CHAMBER,
    ChassisDamagePart.S_CAM,
    ChassisDamagePart.SLACK_ADJUSTER
  ],
  [ChassisDamageLocation.ELECTRICAL]: [
    ChassisDamagePart.SEVEN_WAY_CABLE,
    ChassisDamagePart.SEVEN_WAY_PLUG,
    ChassisDamagePart.SHORT,
    ChassisDamagePart.WIRING
  ],
  [ChassisDamageLocation.FRAME]: [
    ChassisDamagePart.BOLSTER,
    ChassisDamagePart.BOLSTER_GUSSET,
    ChassisDamagePart.CROSSMEMBER,
    ChassisDamagePart.FILLER_PLATE,
    ChassisDamagePart.ICC_BUMPER,
    ChassisDamagePart.ICC_UPRIGHTS,
    ChassisDamagePart.KING_PIN,
    ChassisDamagePart.KING_PIN_PLATE,
    ChassisDamagePart.LIGHT_HOUSING,
    ChassisDamagePart.MAIN_RAIL,
    ChassisDamagePart.MUD_FLAP,
    ChassisDamagePart.MUD_FLAP_BRACKET
  ],
  [ChassisDamageLocation.LANDING_GEAR]: [
    ChassisDamagePart.CRANK_HANDLE,
    ChassisDamagePart.CRANK_HANDLE_RETAINER,
    ChassisDamagePart.CRANK_SHAFT,
    ChassisDamagePart.DUST_COVER,
    ChassisDamagePart.DIAGONAL_BRACE,
    ChassisDamagePart.EAR_BRACKET,
    ChassisDamagePart.GEAR_BOX,
    ChassisDamagePart.GEAR_LEG,
    ChassisDamagePart.MOUNTING_BOX,
    ChassisDamagePart.MOUNTING_BOX_GUSSET,
    ChassisDamagePart.NON_GEAR_LEG,
    ChassisDamagePart.SAND_SHOE,
    ChassisDamagePart.SAND_SHOE_AXLE,
    ChassisDamagePart.SAND_SHOE_AXLE_HOUSING,
    ChassisDamagePart.TIMING_BAR,
    ChassisDamagePart.CROSS_BRACE
  ],
  [ChassisDamageLocation.LIGHTS]: [
    ChassisDamagePart.ABS_LIGHT,
    ChassisDamagePart.LICENSE_PLATE_LIGHT,
    ChassisDamagePart.MARKER_LIGHT,
    ChassisDamagePart.TAIL_LIGHT,
    ChassisDamagePart.ICC_MARKER_LIGHT
  ],
  [ChassisDamageLocation.LOCKS]: [
    ChassisDamagePart.SAFETY_BRACKET,
    ChassisDamagePart.LOCK_GUIDE,
    ChassisDamagePart.LOCK_HANDLE,
    ChassisDamagePart.SAFETY_LATCH,
    ChassisDamagePart.PIN_LOCK,
    ChassisDamagePart.RISER_BLOCK,
    ChassisDamagePart.TWIST_LOCK
  ],
  [ChassisDamageLocation.MARKINGS]: [
    ChassisDamagePart.REFLECTOR,
    ChassisDamagePart.CONSPICUITY_TAPE,
    ChassisDamagePart.UNIT_PREFIX_NUMBER
  ],
  [ChassisDamageLocation.MISC]: [
    ChassisDamagePart.DOCUMENT_HOLDER,
    ChassisDamagePart.LICENSE_PLATE,
    ChassisDamagePart.REGISTRATION
  ],
  [ChassisDamageLocation.SLIDER]: [
    ChassisDamagePart.SLIDER_ASSEBLY,
    ChassisDamagePart.INDEX_HOLE,
    ChassisDamagePart.INDEX_PIN,
    ChassisDamagePart.SLIDER_HANDLE,
    ChassisDamagePart.SLIDER_GUIDE,
    ChassisDamagePart.SLIDER_STOP,
    ChassisDamagePart.SUB_FRAME
  ],
  [ChassisDamageLocation.SUSPENSION]: [
    ChassisDamagePart.AXLE,
    ChassisDamagePart.EQUALIZER,
    ChassisDamagePart.HANGER,
    ChassisDamagePart.REBOUND_BOLT,
    ChassisDamagePart.RADIUS_ROD,
    ChassisDamagePart.SPRING,
    ChassisDamagePart.STABALIZER_BAR,
    ChassisDamagePart.U_BOLTS
  ],
  [ChassisDamageLocation.WHEELS]: [
    ChassisDamagePart.OIL_HUB_CAP,
    ChassisDamagePart.HUB_CAP_GASKET,
    ChassisDamagePart.WHEEL_STUD_NUT,
    ChassisDamagePart.GREASE_HUB_CAP,
    ChassisDamagePart.CLEAT
  ]
};

export type ChassisDamageTypes = {
  [P in ChassisDamageLocation]: {
    [Q in ChassisDamagePart]?: DamageType[];
  };
};

export type ChassisDamageLocationOptions = {
  [P in ChassisDamageLocation]: {
    [Q in ChassisDamagePart]?: { locations: string[] };
  };
};

// export const chassisSystems: ChassisDamageTypes = {
//   [ChassisDamageLocation.AIR_SYSTEM]: {
//     [ChassisDamagePart.AIR_LINE]: {
//       types: [DamageType.CRACKED, DamageType.CUT, DamageType.MISSING, DamageType.LEAKING, DamageType.WORN]
//     },
//     [ChassisDamagePart.AIR_TANK]: {
//       types: [
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.CUT,
//         DamageType.LEAKING,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.GLADHAND]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CRACKED,
//         DamageType.IMPROPER,
//         DamageType.LEAKING,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.GLADHAND_SEAL]: {
//       types: [DamageType.CRACKED, DamageType.CUT, DamageType.LEAKING, DamageType.MISSING, DamageType.WORN]
//     },
//     [ChassisDamagePart.HOSE_SEPARATORS]: {
//       types: [DamageType.BROKEN, DamageType.IMPROPER, DamageType.MISSING]
//     },
//     [ChassisDamagePart.VALVE]: {
//       types: [DamageType.LEAKING, DamageType.MISSING]
//     }
//   },
//   [ChassisDamageLocation.BRAKES]: {
//     [ChassisDamagePart.BRAKE_SHOES]: {
//       types: [DamageType.CRACKED, DamageType.MISSING, DamageType.SATURATED, DamageType.SEPARATED, DamageType.WORN]
//     },
//     [ChassisDamagePart.S_CAM_BUSHING]: {
//       types: [DamageType.FROZEN_OR_SEIZED, DamageType.WORN]
//     },
//     [ChassisDamagePart.BRAKE_DRUM]: {
//       types: [DamageType.BROKEN, DamageType.CRACKED, DamageType.MISSING, DamageType.SATURATED, DamageType.WORN]
//     },
//     [ChassisDamagePart.MAXI_CHAMBER]: {
//       types: [
//         DamageType.BENT,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CUT,
//         DamageType.FROZEN_OR_SEIZED,
//         DamageType.IMPROPER,
//         DamageType.LEAKING,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.S_CAM]: {
//       types: [DamageType.BENT, DamageType.FROZEN_OR_SEIZED, DamageType.MISSING]
//     },
//     [ChassisDamagePart.SLACK_ADJUSTER]: {
//       types: [DamageType.BENT, DamageType.BROKEN, DamageType.FROZEN_OR_SEIZED, DamageType.IMPROPER, DamageType.MISSING]
//     }
//   },
//   [ChassisDamageLocation.ELECTRICAL]: {
//     [ChassisDamagePart.SEVEN_WAY_CABLE]: {
//       types: [DamageType.CUT, DamageType.IMPROPER, DamageType.MISSING, DamageType.SHORT]
//     },
//     [ChassisDamagePart.SEVEN_WAY_PLUG]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.IMPROPER,
//         DamageType.LOOSE,
//         DamageType.MISSING,
//         DamageType.SHORT
//       ]
//     },
//     [ChassisDamagePart.SHORT]: {
//       types: []
//     },
//     [ChassisDamagePart.WIRING]: {
//       types: [DamageType.CUT, DamageType.IMPROPER, DamageType.SHORT]
//     }
//   },
//   [ChassisDamageLocation.FRAME]: {
//     [ChassisDamagePart.BOLSTER]: {
//       types: [DamageType.BENT, DamageType.CORRODED_OR_ROTTED, DamageType.CRACKED, DamageType.CUT]
//     },
//     [ChassisDamagePart.BOLSTER_GUSSET]: {
//       types: [DamageType.BENT, DamageType.CORRODED_OR_ROTTED, DamageType.CRACKED, DamageType.CUT, DamageType.MISSING]
//     },
//     [ChassisDamagePart.CROSSMEMBER]: {
//       types: [DamageType.BENT, DamageType.BROKEN, DamageType.CORRODED_OR_ROTTED, DamageType.CRACKED, DamageType.MISSING]
//     },
//     [ChassisDamagePart.FILLER_PLATE]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.CUT,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.ICC_BUMPER]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.IMPROPER,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.ICC_UPRIGHTS]: {
//       types: [DamageType.BENT, DamageType.BROKEN, DamageType.CORRODED_OR_ROTTED, DamageType.CRACKED, DamageType.MISSING]
//     },
//     [ChassisDamagePart.KING_PIN]: {
//       types: [DamageType.BENT, DamageType.LOOSE, DamageType.MISSING]
//     },
//     [ChassisDamagePart.KING_PIN_PLATE]: {
//       types: [
//         DamageType.BENT,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.MISSING,
//         DamageType.SEPARATED
//       ]
//     },
//     [ChassisDamagePart.LIGHT_HOUSING]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.IMPROPER,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.MAIN_RAIL]: {
//       types: [DamageType.BENT, DamageType.CORRODED_OR_ROTTED, DamageType.CRACKED]
//     },
//     [ChassisDamagePart.MUD_FLAP]: {
//       types: [DamageType.CUT, DamageType.IMPROPER, DamageType.LOOSE, DamageType.MISSING]
//     },
//     [ChassisDamagePart.MUD_FLAP_BRACKET]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.IMPROPER,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     }
//   },
//   [ChassisDamageLocation.LANDING_GEAR]: {
//     [ChassisDamagePart.CRANK_HANDLE]: {
//       types: [DamageType.BENT, DamageType.BROKEN, DamageType.IMPROPER, DamageType.LOOSE, DamageType.MISSING]
//     },
//     [ChassisDamagePart.CRANK_HANDLE_RETAINER]: {
//       types: [DamageType.BENT, DamageType.BROKEN, DamageType.MISSING]
//     },
//     [ChassisDamagePart.CRANK_SHAFT]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.FROZEN_OR_SEIZED,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.DUST_COVER]: {
//       types: [DamageType.BENT, DamageType.BROKEN, DamageType.CORRODED_OR_ROTTED, DamageType.LOOSE, DamageType.MISSING]
//     },
//     [ChassisDamagePart.DIAGONAL_BRACE]: {
//       types: [DamageType.BENT, DamageType.BROKEN, DamageType.CORRODED_OR_ROTTED, DamageType.LOOSE, DamageType.MISSING]
//     },
//     [ChassisDamagePart.EAR_BRACKET]: {
//       types: [DamageType.BROKEN, DamageType.CORRODED_OR_ROTTED, DamageType.LOOSE, DamageType.MISSING]
//     },
//     [ChassisDamagePart.GEAR_BOX]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.FROZEN_OR_SEIZED,
//         DamageType.LOOSE,
//         DamageType.LEAKING,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.GEAR_LEG]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.FROZEN_OR_SEIZED,
//         DamageType.IMPROPER,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.MOUNTING_BOX]: {
//       types: [DamageType.BENT, DamageType.BROKEN, DamageType.CORRODED_OR_ROTTED, DamageType.CRACKED, DamageType.MISSING]
//     },
//     [ChassisDamagePart.MOUNTING_BOX_GUSSET]: {
//       types: [DamageType.BENT, DamageType.BROKEN, DamageType.CORRODED_OR_ROTTED, DamageType.CRACKED]
//     },
//     [ChassisDamagePart.NON_GEAR_LEG]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.FROZEN_OR_SEIZED,
//         DamageType.IMPROPER,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.SAND_SHOE]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.IMPROPER,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.SAND_SHOE_AXLE]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.IMPROPER,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.SAND_SHOE_AXLE_HOUSING]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.IMPROPER
//       ]
//     },
//     [ChassisDamagePart.TIMING_BAR]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.FROZEN_OR_SEIZED,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.CROSS_BRACE]: {
//       types: [DamageType.BENT, DamageType.BROKEN, DamageType.CORRODED_OR_ROTTED, DamageType.CRACKED, DamageType.MISSING]
//     }
//   },
//   [ChassisDamageLocation.LIGHTS]: {
//     [ChassisDamagePart.ABS_LIGHT]: {
//       types: [DamageType.BROKEN, DamageType.BURNED_OUT, DamageType.LOOSE, DamageType.MISSING, DamageType.SHORT]
//     },
//     [ChassisDamagePart.LICENSE_PLATE_LIGHT]: {
//       types: [DamageType.BROKEN, DamageType.BURNED_OUT, DamageType.LOOSE, DamageType.MISSING, DamageType.SHORT]
//     },
//     [ChassisDamagePart.MARKER_LIGHT]: {
//       types: [DamageType.BROKEN, DamageType.BURNED_OUT, DamageType.LOOSE, DamageType.MISSING, DamageType.SHORT]
//     },
//     [ChassisDamagePart.TAIL_LIGHT]: {
//       types: [DamageType.BROKEN, DamageType.BURNED_OUT, DamageType.LOOSE, DamageType.MISSING, DamageType.SHORT]
//     },
//     [ChassisDamagePart.ICC_MARKER_LIGHT]: {
//       types: [DamageType.BROKEN, DamageType.BURNED_OUT, DamageType.LOOSE, DamageType.MISSING, DamageType.SHORT]
//     }
//   },
//   [ChassisDamageLocation.LOCKS]: {
//     [ChassisDamagePart.SAFETY_BRACKET]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.FROZEN_OR_SEIZED,
//         DamageType.IMPROPER,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.LOCK_GUIDE]: {
//       types: [DamageType.BENT, DamageType.BROKEN, DamageType.CORRODED_OR_ROTTED, DamageType.CRACKED, DamageType.WORN]
//     },
//     [ChassisDamagePart.LOCK_HANDLE]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CRACKED,
//         DamageType.FROZEN_OR_SEIZED,
//         DamageType.IMPROPER,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.SAFETY_LATCH]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CRACKED,
//         DamageType.FROZEN_OR_SEIZED,
//         DamageType.IMPROPER,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.PIN_LOCK]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.FROZEN_OR_SEIZED,
//         DamageType.IMPROPER,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.RISER_BLOCK]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.SEPARATED,
//         DamageType.WORN
//       ]
//     },
//     [ChassisDamagePart.TWIST_LOCK]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.FROZEN_OR_SEIZED,
//         DamageType.IMPROPER,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     }
//   },
//   [ChassisDamageLocation.MARKINGS]: {
//     [ChassisDamagePart.REFLECTOR]: {
//       types: [DamageType.BROKEN, DamageType.CRACKED, DamageType.IMPROPER, DamageType.MISSING, DamageType.WORN]
//     },
//     [ChassisDamagePart.CONSPICUITY_TAPE]: {
//       types: [DamageType.CUT, DamageType.IMPROPER, DamageType.MISSING, DamageType.WORN]
//     },
//     [ChassisDamagePart.UNIT_PREFIX_NUMBER]: {
//       types: [DamageType.CUT, DamageType.IMPROPER, DamageType.MISSING, DamageType.WORN]
//     }
//   },
//   [ChassisDamageLocation.MISC]: {
//     [ChassisDamagePart.DOCUMENT_HOLDER]: {
//       types: [DamageType.BROKEN, DamageType.CRACKED, DamageType.LOOSE, DamageType.MISSING, DamageType.WORN]
//     },
//     [ChassisDamagePart.LICENSE_PLATE]: {
//       types: [DamageType.BROKEN, DamageType.CUT, DamageType.IMPROPER, DamageType.MISSING, DamageType.WORN]
//     },
//     [ChassisDamagePart.REGISTRATION]: {
//       types: [DamageType.CUT, DamageType.IMPROPER, DamageType.MISSING, DamageType.WORN]
//     }
//   },
//   [ChassisDamageLocation.SLIDER]: {
//     [ChassisDamagePart.SLIDER_ASSEBLY]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.IMPROPER,
//         DamageType.MISSING,
//         DamageType.WORN
//       ]
//     },
//     [ChassisDamagePart.INDEX_HOLE]: {
//       types: [DamageType.BENT, DamageType.CORRODED_OR_ROTTED, DamageType.CRACKED, DamageType.LOOSE, DamageType.WORN]
//     },
//     [ChassisDamagePart.INDEX_PIN]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.LOOSE,
//         DamageType.MISSING,
//         DamageType.WORN
//       ]
//     },
//     [ChassisDamagePart.SLIDER_HANDLE]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CRACKED,
//         DamageType.IMPROPER,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.SLIDER_GUIDE]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.IMPROPER,
//         DamageType.LOOSE,
//         DamageType.MISSING,
//         DamageType.SEPARATED
//       ]
//     },
//     [ChassisDamagePart.SLIDER_STOP]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.MISSING,
//         DamageType.WORN
//       ]
//     },
//     [ChassisDamagePart.SUB_FRAME]: {
//       types: [DamageType.BENT, DamageType.BROKEN, DamageType.CORRODED_OR_ROTTED, DamageType.CRACKED, DamageType.MISSING]
//     }
//   },
//   [ChassisDamageLocation.SUSPENSION]: {
//     [ChassisDamagePart.AXLE]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.IMPROPER,
//         DamageType.LEAKING,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.EQUALIZER]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.IMPROPER,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.HANGER]: {
//       types: [DamageType.BENT, DamageType.BROKEN, DamageType.CORRODED_OR_ROTTED, DamageType.CRACKED, DamageType.MISSING]
//     },
//     [ChassisDamagePart.REBOUND_BOLT]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.RADIUS_ROD]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.IMPROPER,
//         DamageType.LOOSE,
//         DamageType.MISSING
//       ]
//     },
//     [ChassisDamagePart.SPRING]: {
//       types: [DamageType.BROKEN, DamageType.CRACKED, DamageType.LOOSE, DamageType.MISSING]
//     },
//     [ChassisDamagePart.STABALIZER_BAR]: {
//       types: [DamageType.BENT, DamageType.BROKEN, DamageType.CORRODED_OR_ROTTED, DamageType.CRACKED, DamageType.MISSING]
//     },
//     [ChassisDamagePart.U_BOLTS]: {
//       types: [DamageType.BENT, DamageType.BROKEN, DamageType.CRACKED, DamageType.LOOSE, DamageType.MISSING]
//     }
//   },
//   [ChassisDamageLocation.WHEELS]: {
//     [ChassisDamagePart.OIL_HUB_CAP]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.LEAKING,
//         DamageType.MISSING,
//         DamageType.SATURATED
//       ]
//     },
//     [ChassisDamagePart.HUB_CAP_GASKET]: {
//       types: [DamageType.CORRODED_OR_ROTTED, DamageType.LEAKING]
//     },
//     [ChassisDamagePart.WHEEL_STUD_NUT]: {
//       types: [DamageType.BENT, DamageType.BROKEN, DamageType.IMPROPER, DamageType.LOOSE, DamageType.MISSING]
//     },
//     [ChassisDamagePart.GREASE_HUB_CAP]: {
//       types: [
//         DamageType.BENT,
//         DamageType.BROKEN,
//         DamageType.CORRODED_OR_ROTTED,
//         DamageType.CRACKED,
//         DamageType.LEAKING,
//         DamageType.MISSING,
//         DamageType.SATURATED
//       ]
//     },
//     [ChassisDamagePart.CLEAT]: {
//       types: [DamageType.BROKEN, DamageType.CRACKED, DamageType.IMPROPER, DamageType.LOOSE, DamageType.MISSING]
//     }
//   }
// };

export const chassisDamageLocationOptions: ChassisDamageLocationOptions = {
  [ChassisDamageLocation.AIR_SYSTEM]: {
    [ChassisDamagePart.AIR_LINE]: {
      locations: ['FRONT', 'MIDDLE', 'REAR']
    },
    [ChassisDamagePart.AIR_TANK]: {
      locations: ['FRONT', 'REAR']
    },
    [ChassisDamagePart.GLADHAND]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.GLADHAND_SEAL]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.HOSE_SEPARATORS]: {
      locations: ['REAR']
    },
    [ChassisDamagePart.VALVE]: {
      locations: ['FRONT', 'REAR']
    }
  },
  [ChassisDamageLocation.BRAKES]: {
    [ChassisDamagePart.BRAKE_SHOES]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.S_CAM_BUSHING]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.BRAKE_DRUM]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.MAXI_CHAMBER]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.S_CAM]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.SLACK_ADJUSTER]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    }
  },
  [ChassisDamageLocation.ELECTRICAL]: {
    [ChassisDamagePart.SEVEN_WAY_CABLE]: {
      locations: ['FRONT', 'MIDDLE', 'REAR']
    },
    [ChassisDamagePart.SEVEN_WAY_PLUG]: {
      locations: ['FRONT']
    },
    [ChassisDamagePart.SHORT]: {
      locations: ['FRONT', 'MIDDLE', 'REAR']
    },
    [ChassisDamagePart.WIRING]: {
      locations: ['FRONT', 'MIDDLE', 'REAR']
    }
  },
  [ChassisDamageLocation.FRAME]: {
    [ChassisDamagePart.BOLSTER]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR']
    },
    [ChassisDamagePart.BOLSTER_GUSSET]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR']
    },
    [ChassisDamagePart.CROSSMEMBER]: {
      locations: []
    },
    [ChassisDamagePart.FILLER_PLATE]: {
      locations: ['REAR']
    },
    [ChassisDamagePart.ICC_BUMPER]: {
      locations: ['REAR']
    },
    [ChassisDamagePart.ICC_UPRIGHTS]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.KING_PIN]: {
      locations: ['FRONT']
    },
    [ChassisDamagePart.KING_PIN_PLATE]: {
      locations: ['FRONT']
    },
    [ChassisDamagePart.LIGHT_HOUSING]: {
      locations: ['LEFT REAR', 'RIGHT REAR']
    },
    [ChassisDamagePart.MAIN_RAIL]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.MUD_FLAP]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.MUD_FLAP_BRACKET]: {
      locations: ['LEFT', 'RIGHT']
    }
  },
  [ChassisDamageLocation.LANDING_GEAR]: {
    [ChassisDamagePart.CRANK_HANDLE]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.CRANK_HANDLE_RETAINER]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.CRANK_SHAFT]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.DUST_COVER]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.DIAGONAL_BRACE]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.EAR_BRACKET]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.GEAR_BOX]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.GEAR_LEG]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.MOUNTING_BOX]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.MOUNTING_BOX_GUSSET]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.NON_GEAR_LEG]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.SAND_SHOE]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.SAND_SHOE_AXLE]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.SAND_SHOE_AXLE_HOUSING]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.TIMING_BAR]: {
      locations: ['CENTER']
    },
    [ChassisDamagePart.CROSS_BRACE]: {
      locations: ['CENTER']
    }
  },
  [ChassisDamageLocation.LIGHTS]: {
    [ChassisDamagePart.ABS_LIGHT]: {
      locations: ['REAR']
    },
    [ChassisDamagePart.LICENSE_PLATE_LIGHT]: {
      locations: ['REAR']
    },
    [ChassisDamagePart.MARKER_LIGHT]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.TAIL_LIGHT]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.ICC_MARKER_LIGHT]: {
      locations: ['REAR']
    }
  },
  [ChassisDamageLocation.LOCKS]: {
    [ChassisDamagePart.SAFETY_BRACKET]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.LOCK_GUIDE]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.LOCK_HANDLE]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.SAFETY_LATCH]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.PIN_LOCK]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.RISER_BLOCK]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.TWIST_LOCK]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    }
  },
  [ChassisDamageLocation.MARKINGS]: {
    [ChassisDamagePart.REFLECTOR]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR']
    },
    [ChassisDamagePart.CONSPICUITY_TAPE]: {
      locations: ['LEFT', 'RIGHT', 'REAR']
    },
    [ChassisDamagePart.UNIT_PREFIX_NUMBER]: {
      locations: ['FRONT', 'REAR', 'LEFT', 'RIGHT']
    }
  },
  [ChassisDamageLocation.MISC]: {
    [ChassisDamagePart.DOCUMENT_HOLDER]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.LICENSE_PLATE]: {
      locations: ['REAR']
    },
    [ChassisDamagePart.REGISTRATION]: {
      locations: []
    }
  },
  [ChassisDamageLocation.SLIDER]: {
    [ChassisDamagePart.SLIDER_ASSEBLY]: {
      locations: ['REAR']
    },
    [ChassisDamagePart.INDEX_HOLE]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.INDEX_PIN]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.SLIDER_HANDLE]: {
      locations: ['LEFT']
    },
    [ChassisDamagePart.SLIDER_GUIDE]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.SLIDER_STOP]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.SUB_FRAME]: {
      locations: ['REAR']
    }
  },
  [ChassisDamageLocation.SUSPENSION]: {
    [ChassisDamagePart.AXLE]: {
      locations: ['FRONT', 'CENTER', 'REAR']
    },
    [ChassisDamagePart.EQUALIZER]: {
      locations: ['LEFT', 'RIGHT']
    },
    [ChassisDamagePart.HANGER]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.REBOUND_BOLT]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.RADIUS_ROD]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.SPRING]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.STABALIZER_BAR]: {
      locations: ['FRONT', 'REAR']
    },
    [ChassisDamagePart.U_BOLTS]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    }
  },
  [ChassisDamageLocation.WHEELS]: {
    [ChassisDamagePart.OIL_HUB_CAP]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.HUB_CAP_GASKET]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.WHEEL_STUD_NUT]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.GREASE_HUB_CAP]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    },
    [ChassisDamagePart.CLEAT]: {
      locations: ['LEFT FRONT', 'RIGHT FRONT', 'LEFT REAR', 'RIGHT REAR', 'LEFT CENTER', 'RIGHT CENTER']
    }
  }
};
